<template>
  <div class="page-effect">
    <header
      class="header-navbar sticky-top"
      v-if="EventsData.expiry != undefined"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="d-md-flex align-items-center justify-content-between">
              <div class="left-logo" style="width: 100%">
                <img
                  id="imgBanner"
                  v-bind:src="EventsData.event.EventBanner"
                  alt="e2m"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <section
      class="body-content"
      style="background-color: #ffffff"
      v-if="EventsData.expiry != undefined"
    >
      <div class="wrapper-create-pass py-4 mb-5">
        <div class="container">
          <!------top logo area--->
          <div class="mb-4 text-center">
            <a href="#"> </a>
            <h3 class="login-head mt-4">{{ $t("createPassword.title") }}</h3>
          </div>
          <!------top logo area end--->

          <!----form area start------->

          <div class="row justify-content-center">
            <div class="col-md-5 login-form-hld">
              <!----event banner---->
              <div class="event-reg-speakers">
                <div class="event_banner">
                  <img
                    id="imgBannerEvnt"
                    :src="EventsData.event.EventLogo"
                    alt="e2m"
                  />
                </div>
                <h1 class="page-head mt-4 mb-0">
                  {{ EventsData.event.EventFullName }}
                </h1>
              </div>

              <!----event banner---->
              <form action="/action_page.php">
                <div class="row form-right-hld mt-6">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>
                        {{ $t("createPassword.fname") }}
                        <span class="required" style="color: red"
                          >*</span
                        ></label
                      >
                      <input
                        required="required"
                        type="text"
                        id="txtFName"
                        class="form-control field-disabled"
                        disabled
                        v-model="EventsData.user.FirstName"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>
                        {{ $t("createPassword.lname") }}
                        <span class="required" style="color: red"
                          >*</span
                        ></label
                      >
                      <input
                        required="required"
                        type="text"
                        id="txtLName"
                        class="form-control field-disabled"
                        disabled
                        v-model="EventsData.user.LastName"
                      />
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label>
                        {{ $t("createPassword.email") }}
                        <span class="required" style="color: red"
                          >*</span
                        ></label
                      >

                      <input
                        required="required"
                        type="text"
                        id="txtLName"
                        class="form-control field-disabled"
                        disabled
                        v-model="EventsData.user.Email"
                      />
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group mb-2">
                      <label>
                        {{ $t("createPassword.pass") }}
                        <span class="required" style="color: red"
                          >*</span
                        ></label
                      >
                      <input
                        required="required"
                        type="text"
                        id="txtLName"
                        class="form-control"
                        v-model="userPassword"
                      />
                    </div>
                  </div>
                  <div class="col-md-12 login-form">
                    <p class="field_helper-text">
                      {{ $t("createPassword.passformate") }}
                    </p>

                    <input
                      type="submit"
                      data-tag="loginSubmit"
                      value="Submit"
                      @click.prevent="updateUserPassword"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!----form area end------->
        </div>
      </div>
    </section>

    <div class="modal fade all-modal" id="success-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <span
              class="
                success-icon
                d-flex
                justify-content-center
                align-items-center
              "
            >
              <img src="../assets/Images/icons/tick.svg" />
            </span>
            <p>
              <strong>{{ $t("createPassword.succes_modal_title") }}</strong>
            </p>
            <p>{{ $t("createPassword.succes_modal_description") }}</p>
            <p>
              <span data-dismiss="modal" class="btn-pink sussecc-btn">{{
                $t("createPassword.succes_btn_txt")
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade all-modal error"
      id="error-modal"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <span class="d-flex justify-content-center align-items-center">
              <img src="../assets/Images/icons/cross_error.svg" />
            </span>
            <p>
              <strong>{{ $t("createPassword.error_modal_title") }}</strong>
            </p>
            <p>
              {{ $t("createPassword.error_modal_description") }}
              <a :href="recoverPassLink" target="_blank"> here</a>
            </p>
            <p>
              <strong>{{
                $t("createPassword.error_modal_description_1")
              }}</strong
              ><a :href="origin" target="_blank"> here</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div id="Othermsg-modal" class="modal fade all-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg" class="classOtheMsg">
              {{ $t("createPassword.error_modal_description_2") }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="Othermsg-modal2" class="modal fade all-modal error">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg2" class="classOtheMsg">
              {{ $t("createPassword.error_modal_description_3") }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
        display: none;
      "
    >
      <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
      <div class="loader">
        <!-- <div class="item-c item-1"></div>
        <div class="item-c item-2"></div>
        <div class="item-c item-3"></div>
        <div class="item-c item-4"></div>-->
        <svg
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;270 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <circle
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
              stroke-dasharray="187"
              stroke-dashoffset="610"
            >
              <animate
                attributeName="stroke"
                values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                begin="0s"
                dur="5.6s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;135 33 33;450 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="187;46.75;187"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
            </circle>
          </g>
        </svg>
      </div>
      <!-- </p> -->
    </div>
  </div>
</template>

<script>
import jQuery from "jquery";
let $ = jQuery;
// import db from "../components/firebaseInit";
import router from "../router";
import APIs from "../components/APIInit";
import axios from "axios";
var self;
export default {
  data() {
    return {
      EventsData: [],
      userPassword: null,
      origin: window.location.origin,
      recoverPassLink: window.location.origin + "/#recoverpass",
    };
  },
  beforeCreate() {
    $("#topmenu").hide();
    $("#leftmenu").hide();
  },
  mounted() {
    self = this;
    debugger;
    self.decryptToken();
  },
  methods: {
    decryptToken: function () {
      self = this;
      self.showLoader();
      var urlparam = this.$route.query.gpt;

      var postData = {
        token: urlparam,
      };

      let headers = {
        "Content-Type": "application/json",
        //"x-api-key": APIs.XAPIkey,
      };
      axios
        .post(APIs.ValidateTokenFromMail, JSON.stringify(postData), {
          headers: headers,
        })
        .then((response) => {
          self.hideLoader();
          if (response.data.status == 0) {
            self.EventsData = response.data.result;
          } else {
            self.showSnackbar(
              "This link has expired, redirecting to login page...",
              "error",
              "top"
            );
            setTimeout(() => {
              router.push("/");
            }, 5000);
          }
        })
        .catch((error) => {
          self.hideLoader();
          if (error.data.responseJSON.status == -3) {
            $("#error-modal").modal("show");
          } else if (error.data.responseJSON.status == -1) {
            $("#error-modal").modal("show");
          }
        });
    },
    updateUserPassword: function () {
      if (this.userPassword != null) {
        self = this;
        self.showLoader();
        var urlparam = this.$route.query.gpt;
        var postData = {
          token: urlparam,
          data: {
            password: this.userPassword,
          },
        };

        let headers = {
          "Content-Type": "application/json",
          //"x-api-key": APIs.XAPIkey,
        };
        axios
          .put(APIs.GeneratePasswordFromMail, JSON.stringify(postData), {
            headers: headers,
          })
          .then((response) => {
            if (response.data.status == 0) {
              self.hideLoader();
              $("#success-modal").modal("show");
              setTimeout(() => {
                $("#success-modal").modal("hide");
                router.push({ name: "Login" });
              }, 1500);
            }
          })
          .catch((error) => {
            console.log(error);
            self.hideLoader();
            if (error.data.responseJSON.status == -3.5) {
              $("#Othermsg-modal").modal("show");
            }
          });
      } else {
        $("#Othermsg-modal2").modal("show");
      }
    },
    showLoader: function () {
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },
    hideLoader: function () {
      clearTimeout(this.timerLoader);
      if ($("#divLoading") != null) {
        $("#divLoading").hide();
      }
    },
  },
};
</script>
  <style>
.field_helper-text {
  color: #696e7c;
}
.wrapper-create-pass .media.border.full-width.hosted-box {
  border: 0 !important;
}

.field-disabled {
  background-color: #eee !important;
  cursor: no-drop;
}
.all-modal.error .modal-content {
  background-image: none;
}
</style>